module.exports = __webpack_public_path__ + "img/yp-min.fb226ffa.png";